import store from '../store';

// Get properties from the main state.
export const addMainModuleProps = (payload, mainStore) => {

  // Get user details.
  const user = mainStore.currentUser;

  if (user) {
    if (user.email) payload.user_email = user.email;
    if (user.id) payload.user_id = user.id;

    if (user.roles) {
      const userAuthRoles = user.roles;

      Object.keys(userAuthRoles).forEach(role => {
        payload[`user_${role}`] = userAuthRoles[role];
      });
    }
  }

  // Get details about the current view.
  const view = mainStore.currentView;
  const dashboard_view = mainStore.activeView;

  if (view) {
    if (view.name) payload.current_view_name = view.name;

    if (view.name === 'Dashboard' && dashboard_view) {
      payload.dashboard_view = dashboard_view;
    }
  }

  payload.current_view_path = window.location.pathname;
  payload.current_view_host = window.location.host;

  return payload;
};

// Add properties from Attach, if applicable.
const addAttachModuleProps = (payload) => {

  const s = store.state.attachStudio;

  const brand = s.currentAttachBrand;

  if (brand) {
    if (brand.brandName) payload.current_brand_name = brand.brandName;
    if (brand.brandId) payload.current_brand_id = brand.brandId;
    if (brand.brandSlug) payload.current_brand_slug = brand.brandSlug;
    if (brand.clientSuccessManager) payload.brand_csm_email = brand.clientSuccessManager;
  }

  return payload;
};

const setOptions = (payload, options) => {
  for (const key in options) {
    const option = options[key];

    payload[key] = option;
  }
};

export default function(options) {
  const mainStore = store.state.main;
  const payload = {};

  addMainModuleProps(payload, mainStore);
  addAttachModuleProps(payload);
  setOptions(payload, options);

  payload.user_current_session_duration = window.USER_CURRENT_SESSION_DURATION;

  return payload;
}
